import router from "@/router";
import axiosInstance from "@/composables/axios-instance";
import VueCookies from "vue-cookies";
// import toast from "vue3-toastify";

const state = {
    isAuthenticated: false,
    userName: '',
};

const getters = {
    getIsAuthenticated(state){
        return state.isAuthenticated;
    },
};

const mutations = {
    setAccessAndRefreshToken(state,tokens){
        state.isAuthenticated = true;
        VueCookies.set("ACCESS-TOKEN", tokens.access_token, tokens.expires_in);
        VueCookies.set("TOKEN-TYPE", tokens.token_type)
        VueCookies.set(
          "__ASSETS-REFRESH-TOKEN",
          tokens.refresh_token,
          null,
          null,
          null,
          true,
          "Strict"
        );
    },
    setIsAuthenticated(state){
        state.isAuthenticated = true;
    },
};

const actions = {
    isAuthenticated() {
        return axiosInstance.get('/authenticate/auth/').then(response=>{
            window.location.assign(response.data.auth_url);
        }).catch(error=>{
            console.error(error);
        })
    },
    getAccessAndRefreshToken({commit}){
        return axiosInstance.get('/authenticate/callback/', {
            params:{
                code: router.currentRoute.value.query.code,
                state: router.currentRoute.value.query.state
        }}).then(response=>{
            commit('setAccessAndRefreshToken', response.data);
            router.push({name:'dashboard'});
        }).catch(error=>{
            console.error(error)
        })
    },
    getAccessTokenFromRefreshToken({commit}){
        const refreshToken = VueCookies.get("__ASSETS-REFRESH-TOKEN");
        if (!refreshToken) {
            VueCookies.remove("__ASSETS-REFRESH-TOKEN");
            VueCookies.remove("ACCESS-TOKEN");
            if (router.currentRoute.value.name !== 'login') {
                router.push({name: 'login'});
            }
            return Promise.reject(new Error("No refresh token available"));
        }
        return axiosInstance.get('/authenticate/refresh/', {params: {
            refresh_token: refreshToken
        }}).then(response=>{
            commit("setAccessAndRefreshToken", response.data);
            return response.data;
        }).catch(error=>{
            console.error("Refresh token error:", error);
            VueCookies.remove("__ASSETS-REFRESH-TOKEN");
            VueCookies.remove("ACCESS-TOKEN");
            if (router.currentRoute.value.name !== 'login') {
                router.push({name: 'login'});
            }
            throw error;
        })
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}